"use client";

import { usePathname } from "next/navigation";

import { useWindowSize } from "@/hooks/browser";

export const useIsQREditorStepperVisible = (showStepper?: boolean): boolean => {
  const screenSize = useWindowSize();
  const pathname = usePathname();

  return Boolean(showStepper && !screenSize?.isDesktop && !pathname?.includes("/register"));
};
